import React, { PureComponent } from 'react';
import styled, { css } from 'styled-components';
import moment from 'moment';
import { ReminderStatus } from '../../../../../../Account/Profile/Reminders/util/reminders';
import { colors } from '../../../../../../../constants/colors';
import { fontFamily } from '../../../../../../../constants/text';
import { isReminderComplete } from './util';

const Status = styled.div.withConfig({ componentId: 'sc-hps315-0' })`
  padding: 4px 8px;
  border-radius: 16px;
  text-transform: uppercase;
  align-self: flex-start;
  display: inline-block;
  font-family: ${fontFamily.bold};
  font-size: 10px;
  color: ${colors.mrGray};
  background-color: ${colors.karl};
  margin-bottom: 6px;

  ${({
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'completed' does not exist on type 'Pick<... Remove this comment to see the full error message
    completed,
  }) =>
    completed &&
    css`
      color: ${colors.mrBlueSky};
    `};
`;

type Props = {
  reminder?: object;
};

export default class ReminderFlavor extends PureComponent<Props> {
  get copy() {
    const { reminder } = this.props;
    switch (ReminderStatus.getStatus(reminder)) {
      case ReminderStatus.DONE: {
        const expDate = moment(ReminderStatus.getNextReminderDate(reminder)).format('MMM YYYY');
        return `up to date until ${expDate}`;
      }

      default:
        return 'due for appointment';
    }
  }

  render = () =>
    (this.props.reminder || null) && (
      // @ts-expect-error ts-migrate(2769) FIXME: Property 'completed' does not exist on type 'Intri... Remove this comment to see the full error message
      <Status completed={isReminderComplete(this.props.reminder) || undefined}>{this.copy}</Status>
    );
}
